/** Matches auto Guest IDs like MusicLover_42 */
const GUEST_ID_RE = /^[A-Za-z]+_[0-9]+$/;

export const isGuestIdLabel = (value) => GUEST_ID_RE.test(String(value || '').trim());

/** Chosen display name (e.g. Zoro, Luffy). Handles both current and legacy field layouts. */
export const getGuestDisplayName = (user) => {
  if (!user) return 'Guest';
  const fname = (user.fname || '').trim();
  const lname = (user.lname || '').trim();
  const fullName = `${fname}${lname ? ` ${lname}` : ''}`.trim();
  const guestName = (user.guest_name || user.username || '').trim();

  // New model: fname/lname = chosen label, guest_name = global ID
  if (fullName && fullName !== 'Guest' && !isGuestIdLabel(fullName)) {
    return fullName;
  }
  // Previous model: guest_name = chosen label, fname = global ID
  if (guestName && !isGuestIdLabel(guestName)) {
    return guestName;
  }
  return fullName || guestName || 'Guest';
};

/** Global Guest ID (e.g. MusicLover_42). Handles both current and legacy field layouts. */
export const getGuestId = (user) => {
  if (!user) return null;
  const labeled = (user.guest_id_label || '').trim();
  if (labeled) return labeled;

  const guestName = (user.guest_name || '').trim();
  const fname = (user.fname || '').trim();

  // New model: guest_name = global ID
  if (isGuestIdLabel(guestName)) return guestName;
  // Previous model: fname = global ID
  if (isGuestIdLabel(fname)) return fname;

  return guestName || null;
};
